// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { deferPromise } from "~/util/general";

/**
 * @class Zobrazeni videa
 * @private
 */
export default class Video extends Content {
	constructor(data, options) {
		super(data, options);

		this._scriptUrl = "https://www.televizeseznam.cz/static/embed/api.js";

		this._deleteScripts();
	}

	destroy() {
		this._showButtons();
		super.destroy();
	}

	handleEvent(e) {
		if (e.type == "load") {
			e.target.removeEventListener("load", this);
			this._loadScript();
		}
	}

	loadVideo() {
		if (window.SeznamTvEmbed) {
			this._makeId();
			if (!this._id) { return; }
			new SeznamTvEmbed("frame-" + this._id, {
				episodeId: this._id
			}, {
				version: "1.0",
				denyResponsive: false,
				service: "SeznamTv",
				hostContextId: this._id
			});
		}
	}

	getPosterData() {
		return this._promiseData.promise;
	}

	_build() {
		this._id = null;
		this._promiseData = deferPromise();
		this._makeId();

		if (!this._id) {
			this._promiseData.reject({});

			return;
		}

		let item = Mapy.Util.node("div", { id: "video-" + this._id, className: "video" });

		let iframe = Mapy.Util.node("iframe", { width: "400", height: "210", style: "background:#000;", id: `frame-${this._id}` });
		iframe.setAttribute("allowfullscreen", "1");
		iframe.setAttribute("frameborder", "0");
		iframe.addEventListener("load", this);

		item.appendChild(iframe);

		this._dom.container = item;
		this._promiseData.resolve([item, "video", this]);
		window.SeznamTvEmbed = null;
	}

	/**
	 * Vytvoří z dat ID videa
	 */
	_makeId() {
		let d;
		if (Array.isArray(this._data)) {
			d = this._data;
		} else {
			d = this._data.value;
		}
		this._id = d[0] ? d[0].toString() : null;
	}

	_loadScript() {
		let head = document.getElementsByTagName("head")[0];
		let script = this._createScriptElement(this._scriptUrl);

		window.onSeznamTvEmbedAPIReady = function() {
			var player = new SeznamTvEmbed("frame-" + this._id, {
				episodeId: this._id
			}, {
				version: "1.0",
				denyResponsive: false,
				service: "SeznamTv",
				hostContextId: this._id
			});
			player.addEventListener('play', this._hideButtons);
			player.addEventListener('pause', this._showButtons);
			player.addEventListener('stop', this._showButtons);
			player.addEventListener('ended', this._showButtons);
		}.bind(this);


		head.appendChild(script);
	}

	_createScriptElement(url, callback) {
		let existScript = document.querySelector("frame-" + this._id + "script");
		existScript?.remove();

		let script = Mapy.Util.node("script");
		script.charset = "utf-8";
		script.id = "frame-" + this._id + "script";

		script.type = "text/javascript";
		script.src = url;
		return script;
	}

	_hideButtons() {
		let buttonUpload = document.querySelector("#detail .content-uploadlink .upload-button");
		buttonUpload?.classList.add("hidden");

		let buttonBack = document.querySelector("#detail .button-back");
		buttonBack?.classList.add("hidden");

		let detailSuggest = document.querySelector("#detail .detail-suggest");
		detailSuggest?.classList.add("hidden");
	}

	_showButtons() {
		let buttonUpload = document.querySelector("#detail .content-uploadlink .upload-button.hidden");
		buttonUpload?.classList.remove("hidden");

		let buttonBack = document.querySelector("#detail .button-back.hidden");
		buttonBack?.classList.remove("hidden");

		let detailSuggest = document.querySelector("#detail .detail-suggest.hidden");
		detailSuggest?.classList.remove("hidden");
	}

	/**
	 * Smaže TV skripty
	 */
	_deleteScripts() {
		Array.from(document.head.querySelectorAll("script[src^='https://www.televizeseznam.cz/static/embed']")).forEach(script => {
			script.remove();
		});
	}
}
